module.exports = {
	"name": "monitoring",
	"version": "v1.0.0",
	"private": true,
	"devDependencies": {
		"eslint": "^3.19.0",
		"eslint-config-vtex": "^5.1.0"
	},
	"dependencies": {
		"axios": "^0.21.1",
		"httpasync-sender": "0.0.7",
		"numeral": "^2.0.6",
		"query-string": "^4.3.2",
		"react": "^15.4.2",
		"react-cookie": "^1.0.4",
		"react-dom": "^15.6.2",
		"react-flag-icon-css": "1.0.11",
		"react-icons": "^3.8.0",
		"react-json-tree": "^0.11.0",
		"react-loader": "2.4.0",
		"react-loader-advanced": "^1.6.1",
		"react-router-dom": "^4.3.1",
		"react-scripts": "0.9.0",
		"recharts": "^1.8.5",
		"request-context": "^2.0.0",
		"tachyons": "^4.11.1",
		"type-extensions": "^0.0.9",
		"vtex-tachyons": "^3.2.0"
	},
	"scripts": {
		"start": "react-scripts start",
		"build": "react-scripts build",
		"test": "react-scripts test --env=jsdom",
		"eject": "react-scripts eject"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 563
// module chunks = 0